import ContactForm from "../../../../src/components/contactForm";
import * as React from 'react';
export default {
  ContactForm,
  React
};